<template>
    <v-container fill-height>
        <v-layout row>
            <v-flex xs6 sm5 md3 text-center>
                <v-row>
                    <v-col cols="12">
                        <v-quagga :onDetected="logIt"
                                  :readerTypes="renderTypes"
                        ></v-quagga>
<!--                        <quagga-scanner :onDetected="logIt"-->
<!--                                        :readerType="renderTypes">-->
<!--                        </quagga-scanner>-->
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <h1>{{ text }}</h1>
                    </v-col>
                </v-row>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import EventBus from '@/EventBus'
// import { QuaggaScanner } from 'vue-cc-quaggajs';

export default {
    name: "BarcodeScanWaiting",
    // comments: {
    //     QuaggaScanner
    // },
    data() {
        return {
            text: '',
            readerSize: {
                width: 400,
                height: 400
            },
            renderTypes: [
                'code_39_reader',
                'code_128_reader',
                'code_93_reader',
            ]
        }
    },
    mounted() {
        window.scrollTo(0, 0)
        EventBus.$emit('set_navigation', {title: 'BARCODE SCAN', back_route: 'waiting-parcel'})
    },
    methods: {
        logIt(data) {
            // this.text = data.codeResult.code
            // alert(data.codeResult.code)
            // console.log('detected', data)

            let parcel = this.getLocalItem();
            parcel.barcode = data.codeResult.code
            localStorage.setItem('parcel', JSON.stringify(parcel))

            return this.$router.push({name: 'waiting-parcel'})
        },
        onDecode (result) {
            console.log(result)
            alert(result)
        },
        onLoaded (result) {
            console.log(result)
            alert(result)
        }
    }
}
</script>

<style scoped>

</style>
